import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalAgregarMateriaPrima from "views/Modulos/Administracion/MateriaPrima/ModalAgregarMateriaPrima.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class MateriaPrima extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreMateria: '',
      DescripcionMateria: '',
      idUnidadMedida: '',
      Titulo: '',
      materiasPrimas: [],
      UnidadesMedidas: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombre: false,
      errorDescripcion: false,
      errorIdUnidadMedida: false,
      materiasPrimasMostrar: [],
      entroFiltrar: false,
      notificacion: false,
      Material:[]
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarMateriaPrima = this.eliminarMateriaPrima.bind(this);
    this.filtrarMateriaPrima = this.filtrarMateriaPrima.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerMateriaPrimaFin();
    this.obtenerAllMateriasPrimas();
    this.obtenerAllUnidadesMedida();
  }
  componentWillMount(){
    this.obtenerMateria();
  }

  //Obtener todos los registros guardados
  obtenerAllMateriasPrimas() {
    fetch(Globales.Url + 'MateriaPrima/MateriaPrima/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ materiasPrimas: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ materiasPrimas: data.mensaje });
        }
      });
  }

  //Obtener Materia
  obtenerMateria(){
    //Obtener material
    fetch(Globales.Url + 'Material/Material/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
      //console.log("🍺 / file: MateriaPrima.jsx / line 91 / data", data)
        if (data.error) { //Error al obtener los registros
          this.setState({ Material: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ Material: data.data });
        }
      });
  }

  //Obtener las unidades de medida
  obtenerAllUnidadesMedida() {
    fetch(Globales.Url + 'UnidadMedida/UnidadMedida/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {

        if (data.error) {
          this.setState({ idUnidadMedida: [] });
        } else {
          this.setState({ UnidadesMedidas: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerMateriaPrimaFin() {
    fetch(Globales.Url + 'MateriaPrima/MateriaPrima/ListaMateriasPrimas', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            this.setState({ materiasPrimasMostrar: data.mensaje });
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Obteniendo el nombre de la unidad de medida
  obtenerNombresUnidadMedida(idUnidadMedida) {
    var nombre = "";
    this.state.UnidadesMedidas.map(unidad => {
      if (unidad._id == idUnidadMedida) {
        nombre = unidad.NombreUnidad
      }
    })
    return nombre;
  }

  //Función de editar registro
  editarEstatusPedido(id, Nombre, DescripcionMateria, idUnidadMedida) {
    this.setState({ _id: id, NombreMateria: Nombre, DescripcionMateria: DescripcionMateria, idUnidadMedida: idUnidadMedida, op: 1, showAgregar: true, Titulo: "Editar Materia Prima" });
  }

  //Función de eliminar registro
  eliminarMateriaPrima(id) {
    fetch(Globales.Url + 'MateriaPrima/MateriaPrima/BajaMateriaPrima', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerMateriaPrimaFin();
        this.limpiar();
        this.obtenerAllMateriasPrimas();
        this.obtenerAllUnidadesMedida();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarMateriaPrima(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarMateriaPrima = () => {
    this.setState({ showAgregar: true, Titulo: "Nueva Materia Prima", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalMateriaPrima = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nueva Materia Prima", NombreMateria: "", op: 0 })
    this.obtenerMateriaPrimaFin();
    this.obtenerAllMateriasPrimas();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarMateriaPrima() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreMateria.trim() == '') {
      this.setState({ errorNombre: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreMateria: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'MateriaPrima/MateriaPrima/FiltrarMateriaPrimaNombre', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {

          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",materiasPrimasMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', materiasPrimasMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreMateria: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerMateriaPrimaFin();
    this.obtenerAllMateriasPrimas();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.materiasPrimas.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerMateriaPrimaFin();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.materiasPrimas.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.materiasPrimas.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerMateriaPrimaFin();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (!global.entrar && this.state.materiasPrimas.length <= 5) {
        this.setState({ mensaje: 'No hay más materias primas para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }
  obtenerExistencia(e){
    var suma=0;
    this.state.Material.map(material => {
      if (material.idMateriaPrima === e) {
        //Sumando el total de existencia de materiales de la materia prima seleccionada
        suma = suma + material.Existencia
        //Agregando los materiales de la materia prima
      }
    });
    return suma;
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <ModalAgregarMateriaPrima
          Titulo={this.state.Titulo}
          NombreMateria={this.state.NombreMateria}
          DescripcionMateria={this.state.DescripcionMateria}
          idUnidadMedida={this.state.idUnidadMedida}
          UnidadesMedidas={this.state.UnidadesMedidas}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalMateriaPrima}
          op={this.state.op}
          classes={this.props}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Materias Primas</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar materia prima"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreMateria,
                        name: "NombreMateria",
                        id: "NombreMateria",
                        type: "text",
                        error: this.state.errorNombre
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarMateriaPrima()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarMateriaPrima()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de materiasPrimas */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Materias Primas</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre Materia Prima</th>
                        <th className="center">Unidad de Medida</th>
                        <th className="center">Existencia</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.materiasPrimasMostrar.map(MateriaPrimas => {
                          return (
                            <tr key={MateriaPrimas._id}>
                              <td>{MateriaPrimas.NombreMateria}</td>
                              <td>{this.obtenerNombresUnidadMedida(MateriaPrimas.idUnidadMedida)}</td>
                              <td>{this.obtenerExistencia(MateriaPrimas._id)}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarEstatusPedido(MateriaPrimas._id, MateriaPrimas.NombreMateria, MateriaPrimas.DescripcionMateria, MateriaPrimas.idUnidadMedida)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(MateriaPrimas._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Materia Prima"}
            Cuerpo={"¿Está seguro que desea eliminar la materia prima?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(MateriaPrima);